import React, {useState, useRef, useEffect} from 'react';
import {ICONS} from '../../Constants/Icons';
import MenuIcon from '../SideMenu/MenuIcon';
import {AllMenus} from '../../Constants/SideMenusArray';
import {useNavigate} from 'react-router-dom';
import AppEmptyList from '../../Component/AppEmptyList';
import AppConstantsMessage from '../../Constants/AppConstantsMessage';
import {addMixpanelEvent, MixpanelEvent} from '../../Models/MixPannelEnum';
import useDebounce from '../../hooks/useDebounce';
import {useLocale} from '../../Localization/LocaleContext';

const TopSearcher = ({sidebar = false, sidebarTextColor = '#ffffff'}) => {
  const [search_text, setSearchText] = useState('');
  const [searched_menus, setSearchedMenus] = useState([]);
  const [isSearchListOpen, setISOpenSearchList] = useState(false);

  const searchBoxRef = useRef(null); // Create a ref for the search box container
  const navigate = useNavigate();
  const {translate} = useLocale();

  const menu_click = menu => {
    if (menu.href && (!menu?.sub_menus || menu?.sub_menus?.length === 0)) {
      menu?.isOpenNewTab
        ? window.open(menu.href, '_blank')
        : navigate(menu.href);
    }
    setISOpenSearchList(false);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = event => {
      if (
        searchBoxRef.current &&
        !searchBoxRef.current.contains(event.target)
      ) {
        setISOpenSearchList(false);
      }
    };

    // Add event listener for clicks
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  //
  const searchTextHandler = useDebounce(async e => {
    if (e?.target?.value.length > 1) {
      addMixpanelEvent(MixpanelEvent.spotlight, {
        search_value: e.target.value,
        searched_items_quantity: AllMenus?.filter(mn =>
          mn.title.toLowerCase().includes(search_text?.toLocaleLowerCase()),
        )?.length,
      });
    }
  }, 1000);

  return (
    <div
      className={`h-[36px] w-full rounded-[8px] flex items-center justify-start gap-2 relative px-3 ${
        sidebar
          ? 'bg-transparent'
          : 'max-w-[250px] md:max-w-[400px] h-[42px] border border-[var(--color-border)] bg-[var(--color-input)]'
      }`}
      ref={searchBoxRef}
    >
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={sidebar ? sidebarTextColor : 'var(--color-text-secondary)'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{flexShrink: 0, opacity: sidebar ? 0.7 : 1}}>
        <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
      </svg>
      <input
        placeholder={translate("common.search")}
        type="text"
        className={`h-full flex-grow w-full border-none outline-none focus:outline-none focus:ring-0 text-sm bg-transparent ${sidebar ? 'sidebar-search-input' : 'non-sidebar-search-input'}`}
        style={{color: sidebar ? sidebarTextColor : 'var(--color-text)'}}
        value={search_text}
        onChange={e => {
          setSearchText(e.target.value);
          searchTextHandler(e);

          if (e.target.value?.length > 0) {
            setISOpenSearchList(true);
          } else {
            setISOpenSearchList(false);
          }
          setSearchedMenus(
            AllMenus?.filter(mn =>
              translate(mn.title).toLowerCase().includes(e.target.value.toLocaleLowerCase()) ||
              mn.title.toLowerCase().includes(e.target.value.toLocaleLowerCase()),
            ),
          );
        }}
      />

      {isSearchListOpen && (
        <div className="w-full bg-[var(--color-surface)] border border-[var(--color-border)] rounded-md absolute top-[48px] left-0 min-h-[200px] max-h-[200px] overflow-y-scroll shadow-lg">
          {searched_menus?.length > 0 &&
            searched_menus?.map(item => {
              return (
                <div
                  key={item.title}
                  className="p-2 px-4 flex items-center justify-start gap-4 cursor-pointer hover:bg-[var(--color-table-header)] text-sm text-[var(--color-text)]"
                  onClick={() => menu_click(item)}>
                  <MenuIcon title={item.title} size={20} />
                  {translate(item?.title)}
                </div>
              );
            })}

          {searched_menus?.length === 0 && (
            <div className=" my-10">
              <AppEmptyList showImage={true} />
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default TopSearcher;
